// import Vue from 'vue';
import * as types from '@/store/mutation-types';
import log from '@/logger';

export default {
  [types.appendUndo](state, undoable) {
    log.debug('undoMutations::appendUndo:', undoable);
    if (undoable.undoStrategy === 'undo' || undoable.undoStrategy === 'redo') {
      return;
    }

    if (!undoable.undoStrategy || undoable.undoStrategy === 'init') {
      undoable.undoStrategy = 'init';
      state.undoBufferCursor++;
      state.undoBuffer[state.undoBufferCursor] = [];
    }

    var cursor = state.undoBufferCursor;
    state.undoBuffer[cursor].push(JSON.stringify(undoable));

    while (state.undoBuffer[cursor + 1]) {
      cursor++;
      delete state.undoBuffer[cursor];
    }
  },
  [types.undo](state) {
    state.undoBufferCursor--;
  },
  [types.redo](state) {
    state.undoBufferCursor++;
  },
  [types.clearUndo](state) {
    state.undoBufferCursor = 0;
    state.undoBuffer = {};
  },
};



// WEBPACK FOOTER //
// ./src/store/undo/undoMutations.js